import { useInfinitePaginated } from "../../../../shared/hooks/useInfinitePaginated";
import { userKeys } from "../keys";
import { userApi } from "../service";
import { UserFilters } from "@myapp/contract";

export function useUsersInfiniteQuery(filters: UserFilters, options?: { enabled?: boolean }) {
    return useInfinitePaginated({
        queryKey: userKeys.list(filters),
        params: filters,
        fetchFn: ({ page, ...rest }) =>
            userApi.search({ ...rest, page }).then(r => r.data),
        enabled: options?.enabled,
    })
}